import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import store from 'src/store';
import { LOGIN, FETCH_USER } from 'src/store/types';
import { hasAuthHeader } from 'src/utils/auth';
import { BfSpinner } from 'components/Butterfly';
export default Vue.extend({
    components: { BfSpinner },
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    beforeRouteEnter(to, from, next) {
        if (store.getters.loggedIn === true) {
            const { rawNextLocation } = from.query;
            const nextLocation = Array.isArray(rawNextLocation) ? rawNextLocation[rawNextLocation.length - 1] : rawNextLocation;
            next(nextLocation || { name: 'start' });
        }
        else {
            next();
        }
    },
    props: {
        sso: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            email: '',
            password: '',
            loginError: null,
            loginAttempt: false,
            loading: true,
        };
    },
    computed: {
        ...mapGetters([
            'userName', 'loggedIn', 'serverErrors', 'validationErrors', 'hasRequestErrors',
        ]),
        error() {
            return this.$route.params.auth0Error
                || this.$route.query.auth0Error;
        },
        nextLocation() {
            const { next } = this.$route.query;
            // pick last occurrence of next parameter. consistent with:
            //   new URLSearchParams(location.search).get('next')
            return Array.isArray(next) ? next[next.length - 1] : next;
        },
        loginType() {
            if (process.env.BYPASS_AUTH0 === 'true') {
                return 'dev';
            }
            return 'auth0';
        },
        // When in an iframe we can't rely on accessing the browser storage and
        // auth0 does not allow itself to be rendered (CORS error). So - we must
        // use the pop up method of authentication and manually attach the JWT
        // for authentication.
        inIFrame() {
            return (top !== self);
        },
    },
    async mounted() {
        this.loading = false;
        // Can we automatically log the user in? Only if the user is logged out
        if (this.loggedIn === false) {
            if (hasAuthHeader()) {
                this.loginAttempt = true;
                this.$store.dispatch(FETCH_USER).then(() => {
                    if (this.hasRequestErrors) {
                        this.loginAttempt = false;
                    }
                    else {
                        this.$router.push(this.nextLocation || { name: 'start' });
                    }
                });
            }
            else {
                this.loginAttempt = false;
                // retry login if there is no error on mount.
                if (!this.error && !this.inIFrame) {
                    setTimeout(() => {
                        this.doLogin();
                    }, 300);
                }
                // pass auth0 query parameter errors through as auth0 param errors:
                // as a param error the error is visible when mounted, but if the user
                // refreshes the page (which removes route context) the SSO login
                // method will retry on mount (consistent with other auth0 param errors)
                else if (typeof this.$route.query.auth0Error === 'string') {
                    // this also removes the long query "auth0Error" parameter from the URL
                    // making it look a bit more friendly
                    const { auth0Error, ...query } = this.$route.query;
                    this.$router.replace({
                        query,
                        params: {
                            auth0Error,
                        },
                    });
                }
            }
        }
    },
    methods: {
        ...mapActions({ LOGIN }),
        async doLogin() {
            this.loginError = null;
            const login = async () => {
                this.loginAttempt = true;
                await this.$store.dispatch({
                    type: LOGIN,
                    email: this.email,
                    usePopup: this.inIFrame,
                });
            };
            if (this.loginType === 'auth0') {
                login();
            }
            else {
                const valid = await this.$validator.validateAll();
                valid && login();
            }
        }
    }
});
